import { post } from '../core';

/**
 * Track a user click action. Non-blocking: errors are swallowed by callers.
 * @param {'liveSupportClicks'|'bookCalendlyClicks'|'visitRobocentClicks'} action
 */
export async function trackClick(action) {
  try {
    await post('/activity/click', { action }, { timeout: 4000 });
    return true;
  } catch (e) {
    // Non-blocking: log and continue
    console.warn('trackClick failed (non-blocking):', e?.message || e);
    return false;
  }
}

export default { trackClick };


